import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { FeedbackModule, VWFeedbackAndCategoryModule } from './feedback.module';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {
    httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' })
    };

    private headers: HttpHeaders;
    constructor(private http: HttpClient) {
        this.headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
    }

    getService(): Observable<FeedbackModule[]> {
        return this.http.get<FeedbackModule[]>(environment.apiURL + 'WebTools/WBFeedback/');
    }


    getServiceId(id: number): Observable<FeedbackModule[]> {
        return this.http.get<FeedbackModule[]>(environment.apiURL + 'WebTools/WBFeedback/' + id);
    }


    deleteService(id: number) {
        return this.http.delete(environment.apiURL + 'WebTools/WBFeedback/' + id).toPromise();
    }

    formData: FeedbackModule = new FeedbackModule();
    list: FeedbackModule[];

    postService() {
        return this.http.post(environment.apiURL + 'WebTools/WBFeedback/', this.formData);
    }

    putService() {
        return this.http.put(environment.apiURL + 'WebTools/WBFeedback/' + this.formData.wbFeedbackID, this.formData);
    }







    getServiceVW(): Observable<VWFeedbackAndCategoryModule[]> {
        return this.http.get<VWFeedbackAndCategoryModule[]>(environment.apiURL + 'WebTools/VWFeedbackAndCategory/');
    }
}
